import { render, staticRenderFns } from "./BlockContactModal.vue?vue&type=template&id=efcce440&scoped=true&"
import script from "./BlockContactModal.vue?vue&type=script&lang=js&"
export * from "./BlockContactModal.vue?vue&type=script&lang=js&"
import style0 from "./BlockContactModal.vue?vue&type=style&index=0&id=efcce440&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcce440",
  null
  
)

export default component.exports